<div class="pt-4 px-1">
    <div class="col-12 d-flex flex-wrap">
        <h5 class="text-uppercase me-auto">{{idsAuction | translate}}</h5>
        <p>
            <button id="infoDropdown" name="infoDropdown" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed"
              aria-controls="collapseExample" [ngClass]="{'gold-auction':isGoldAuction, 'marketplace-auction':!isGoldAuction}">
              {{idsWhatIs | translate}}
              <fa-icon [icon]="faChevronDown" size="sm" [ngClass]="{'gold-auction':isGoldAuction, 'marketplace-auction':!isGoldAuction}"></fa-icon>
            </button>
        </p>
    </div>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <div class="card mb-3">
            <div class="row g-0">
                <!--<div class="col-sm-6 col-md-4">
                    <img src="/assets/img/home-gold.jpeg" class="img-fluid">
                    <img src="/assets/img/home-marketplace.png" class="img-fluid">
                </div>-->
                <div class="col-sm-12 col-md-12">
                    <div class="card-body">
                        <p class="card-text">{{idsTitleHome | translate}}</p>
                        <div class="card-text" [innerHTML]="idsHome | translate"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
